"use client";
import React from "react";
import ShopInfo from "components/home/ShopInfo";
import ListDays from "components/home/ListDays";
import ShopService from "services/shop";
import MerchantService from "services/merchant";
import usePromise from "hooks/usePromise";
import { get, map } from "utils/lodash";
import dayjs from "utils/dayjs";

export default function HeaderDetail({
  onChangeDate,
}: {
  onChangeDate?: (date: string) => void;
}) {
  const month = dayjs().month() + 1;
  // TODO: Enable when calculateMonthlyRevenue API is available on backend
  // Temporarily disabled - waiting for backend API implementation
  const monthlyRevenue = null; // Mock data until API is ready

  // Original code - uncomment when API is ready:
  // const [monthlyRevenue] = usePromise(async () => {
  //   const res = await MerchantService.calculateMonthlyRevenue({
  //     input: { month: month, year: dayjs().year() },
  //   });
  //   return get(res, "data");
  // });
  return (
    <div className="bg-gray-01">
      <div className="flex flex-col bg-white gap-3 shadow-sm pb-4 rounded-b-xl mb-3">
        <ShopInfo monthlyRevenue={monthlyRevenue} month={month} />
        <ListDays onChange={onChangeDate} />
      </div>
    </div>
  );
}
